import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
  providedIn: 'root'
})
export class BeneficiosService {
    public httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
        })                                                                                                                                                                         
    };


API_ENDPOINT: string = Constants.BASEURLAPI;


  constructor(private httpClient: HttpClient) { }






}